import { request } from "@/utils/request";

// H5:根据code获取文件详情
export async function fetchFileContent(params) {
  return request({
    url: '/foundation/v1/foundation-agreement-info-code',
    method: "GET",
    params,
  });
}